module.exports = __webpack_public_path__ + "img/SC2-about.7565b06f.svg";